import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import teleImg from '../image/tele_img1.png';
import logo from '../image/pt_bg.png';
import linkImg from '../image/tele_bg.jpeg';
import classes from './pages.module.css';
import TextFull from "../components/Ui/text/textFull";
import LinkList from "../components/Ui/block/linkList";
import Opt from './Opt';
import Rele from './Rele';

const Tele = () => {
    const [blocks, setBlocks] = useState([
        {id:1, title: 'ОПТИЧЕСКОЕ ОБОРУДОВАНИЕ', linkImg: (linkImg), linkto: '/opt' },
        {id:2, title: 'РАДИОРЕЛЕЙНОЕ ОБОРУДОВАНИЕ', linkImg: (linkImg), linkto: '/rele'  },
    ])
    const [lists, setlists] = useState([])
    return (
        <>
            <div className={classes.teleTop}>
                <Container fluid="md">
                    <div className={classes.actContent}>
                        <div className={classes.text}>
                            <h1>Телекоммуникационные системы</h1>
                            <div className={classes.divider}></div>
                            <p>Телекоммуникационные системы служат фундаментальным компонентом современного общества, облегчая обмен информацией на огромных расстояниях. Эти системы включают в себя множество технологически сложных инструментов, таких как оптическое и радиорелейное оборудование, которые поддерживают сети пятого поколения и облегчают плавную модернизацию исторически устаревших сетей мультиплексирования с временным разделением (TDM). Учитывая появление новых сервисов, требующих пропускной способности усилителя и повышенной плотности потоковой передачи, развитие телекоммуникационных систем приобрело беспрецедентный уровень важности.</p>
                        </div>
                        <img src={teleImg} alt="телекомуникационные решения" />
                    </div>
                </Container>
                <div className={classes.topBg}></div>
            </div>
            <TextFull text={{
                    title: 'РЕШЕНИЕ',
                    body: 'Инновация, примененная в данном оборудовании, расширяет использование контейнеров OTN для инкапсуляции PDH/ VCx/ OCxс 100%-ной эффективностью, что позволяет оператору вывести из эксплуатации любое оборудование PDH / SDH / Sonet с их транспортной сети, продолжая поддерживать существующие сервисы и пользовательские интерфейсы клиентов, одновременно увеличивая пропускную способность системы до четырех раз по сравнению с существующей сетью доступа.'
                }}
            lists={lists} />
            <LinkList blocks={blocks} logo={logo} />
            <Routes>
                <Route path="/opt" element={<Opt />} />
                <Route path="/rele" element={<Rele />} />
            </Routes>
        </>
    )
}

export default Tele;